export const USER_MANAGEMENT = 'USER MANAGEMENT'
